import { CountryIso2 } from 'react-international-phone';
import { PhoneNumberUtil } from 'google-libphonenumber';

/**
 * Maps a phone number to its corresponding ISO2 country code using Google's libphonenumber.
 * This accurately distinguishes between countries that share dial codes (e.g., US/Canada/Mexico for +1).
 *
 * @param phoneNumber - Full phone number (e.g., "+12345678900", "12345678900", "+1 (234) 567-8900")
 * @returns ISO2 country code (e.g., "us", "ca", "mx")
 */
export const getCountryIso2FromDialCode = (
  phoneNumber?: string,
): CountryIso2 => {
  if (!phoneNumber) return 'us';

  try {
    const phoneUtil = PhoneNumberUtil.getInstance();

    const cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');

    const formattedNumber = cleanedNumber.startsWith('+')
      ? cleanedNumber
      : `+${cleanedNumber}`;

    const number = phoneUtil.parse(formattedNumber, 'US'); // Default region for parsing

    const regionCode = phoneUtil.getRegionCodeForNumber(number);

    return (regionCode?.toLowerCase() || 'us') as CountryIso2;
  } catch (error) {
    console.warn('Failed to parse phone number:', phoneNumber, error);

    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    if (cleanedNumber.startsWith('1')) {
      return 'us';
    }

    return 'us';
  }
};
